import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1863.05882,1016.47059 C1863.05882,891.896471 1761.75059,790.588235 1637.17647,790.588235 L1203.36941,790.588235 C1183.71765,790.588235 1166.32471,781.214118 1155.70824,764.724706 C1145.31765,748.574118 1143.84941,729.148235 1151.86824,711.529412 C1206.64471,590.456471 1246.73882,464.414118 1271.24706,337.016471 C1287.17176,253.44 1265.37412,167.943529 1211.16235,102.437647 C1157.28941,37.3835294 1078.00471,0 993.750588,0 L846.588235,0 L846.588235,56.4705882 C846.588235,310.927059 691.52,529.694118 561.524706,668.498824 C488.790588,745.976471 384.545882,790.588235 275.557647,790.588235 L56,790.588235 L56,1524.70588 C56,1742.68235 233.317647,1920 451.294118,1920 L1411.29412,1920 C1535.86824,1920 1637.17647,1818.69176 1637.17647,1694.11765 C1637.17647,1647.69882 1623.05882,1604.44235 1599.00235,1568.52706 C1686.87059,1537.58118 1750.11765,1453.66588 1750.11765,1355.29412 C1750.11765,1308.87529 1736,1265.61882 1711.94353,1229.70353 C1799.81176,1198.75765 1863.05882,1114.84235 1863.05882,1016.47059",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconLikeSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconLikeSolid, _Component);

  var _super = _createSuper(IconLikeSolid);

  function IconLikeSolid() {
    _classCallCheck(this, IconLikeSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconLikeSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconLike",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconLikeSolid.displayName = "IconLikeSolid";
  return IconLikeSolid;
}(Component);

IconLikeSolid.glyphName = 'like';
IconLikeSolid.variant = 'Solid';
IconLikeSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconLikeSolid;
export { IconLikeSolid };